export default __webpack_public_path__ + "static/media/ic-opensea.e317f7e4.svg";